import React from "react";
import { bind } from "decko";
import { listLoggedInServers } from "./include/Server";
import GenericBlackBtn from "./GenericBlackBtn";

const formatDate = (date) => {
        const d = new Date(date);
        return d.toLocaleString();
};

const renderError = (errorMsg) => {
    return (
        <a className="list-group-item clickable text-center" style={{
            color: "red",
            fontSize: "20px",
            fontWeight: "bold"
        }}>{errorMsg}</a>
    );
};

const isValidStream = (stream)  => {
    return stream.start_timestamp
        && stream.game
        && stream.game.home_team
        && stream.game.visiting_team
        && stream.game.start_time;
};

const renderInvalidStream = (stream) => {
    return (
        <a className="list-group-item text-center" style={{color: "red", fontWeight: "bold"}} key={stream.key}>
            Error: Unknown stream - {stream.id} - not connected to a game or missing required fields.
        </a>
    );
};

const renderStreamLabel = (stream) => {
    return stream.game.home_team.name + " vs. " +  stream.game.visiting_team.name +
        ", " + formatDate(stream.game.start_time) + " (" + (stream.duration_ms / 1000 / 60).toFixed(0) + " minutes)";
};

const renderSimpleStreamLabel = (stream) => {
    return formatDate(stream.start_timestamp) + " (" + (stream.duration_ms / 1000 / 60).toFixed(0) + " minutes)";
};

const StreamPickerPage = ({heading, buttonClick, buttonLabel, children}) => {
    return (
        <div className="list-group stream-picker">
            <div className="list-group-item text-center">
                <h3>
                    {heading}
                </h3>
                <GenericBlackBtn
                    style={{
                        position: "absolute",
                            right: "5px",
                            top: "5px",
                    }}
                    btnClassName="btn-lg"
                    onClick={buttonClick} >
                    {buttonLabel}
                </GenericBlackBtn>
            </div>
           {children}
        </div>
    );
};

const StreamPickerItem = ({onClick, children}) => {
    return (
        <a className="list-group-item clickable text-center"
            onClick={onClick}>
            {children}
        </a>
    );
};

class GameStreamPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: "games",
            errorMsg: "",
            selectedGame: null,
            games: [],
            streams: []
        };
    }

    componentDidMount() {
        this.loadGamesFromServer(new Date().toISOString().slice(0, 10));
    }

    @bind
    onSelectGame(game) {
        this.setState({
            selectedGame: game
        });
        this.loadStreamsFromServer(game);
    }

    loadGamesFromServer (date) {
        let servers = listLoggedInServers();
        let newGames = [];
        let successCnt = 0;

        const compareGames = (a, b) => {
            let diff = Date.parse(a.start_time) - Date.parse(b.start_time);
            if(diff === 0) {
                return a.key.localeCompare(b.key);
            }
            return diff;
        };

        const handleGames = (games, server) => {
            games.forEach((game) => {
                game.key = server.name + game.id;
                game.server = server;
            });

            newGames = newGames.concat(games);

            if (++successCnt === servers.length) {
                // Set deterministic ordering to avoid flickering - show newest game first
                newGames = newGames.sort(compareGames);
                this.setState({
                    errorMsg: "",
                    games: newGames
                });
            }
        };

        servers.forEach((server) => (
            server.get("/game?from_date=" + date + "&to_date=" + date, (data) => (
                handleGames(data.games, server)
            ), (error) => {
                console.error("Problem fetching games from the server " + error);
                this.setState({
                    errorMsg: "Error fetching games from the server (" + server.name + "): " + error
                });
            })
        ));
    }

    loadStreamsFromServer (game) {
        let server = game.server;

        const handleStreams = (streams, server) => {
            streams.forEach((stream) => {
                stream.key = server.name + "_" + stream.id;
                stream.server = server;
            });

            // Set deterministic ordering to avoid flickering - show oldest stream first
            streams = streams.sort((a,b) => b.duration_ms - a.duration_ms);
            this.setState({
                errorMsg: "",
                streams: streams
            });
        };

        server.get("/game/" + game.id + "/videoassets", (data) => (
            handleStreams(data.videoassets, server)
        ), (error) => {
            console.error("Problem fetching streams from the server " + error);
            this.setState({
                errorMsg: "Error fetching streams from the server (" + server.name + "): " + error
            });
        });
    }

    setDate (date) {
        // If unselect, choose today
        if (date === "") date = (new Date()).toISOString().split("T")[0];

        this.setState({
            date: date,
            games: [],
            selectedGame: null
        });
        this.loadGamesFromServer(date);
    }

    renderGame (game) {
        return  (
            <StreamPickerItem key={game.id} onClick={() => { this.onSelectGame(game); this.setState({page: "streams"}); }}>
                {game.home_team.name} vs. {game.visiting_team.name}, {formatDate(game.start_time)}
            </StreamPickerItem>
        );
    }

    renderGames () {
        let gameListItems;

        if (this.state.errorMsg) {
            gameListItems = renderError(this.state.errorMsg);
        } else {
            gameListItems = this.state.games.map((game) => this.renderGame(game));
        }

        return (
            <StreamPickerPage
                heading={"Games"}
                buttonClick={this.props.buttonClick}
                buttonLabel={"Live streams"}>
                <div className="list-group-item text-center">
                    <input className="form-control"
                        type="date"
                        ref="datePicker"
                        onChange={(ev) => this.setDate(ev.target.value)} />
                </div>
                {gameListItems}
            </StreamPickerPage>
        );
    }

    renderStreams () {
        let streamListItems;
        let game = this.state.selectedGame;

        if (this.state.errorMsg) {
            streamListItems = renderError(this.state.errorMsg);
        } else {
            streamListItems = this.state.streams.map((stream) => (
                isValidStream(stream) ?
                    <StreamPickerItem
                        key={stream.id}
                        onClick={() => this.props.onStartStream(stream)}>
                        {renderSimpleStreamLabel(stream)}
                    </StreamPickerItem> :
                    renderInvalidStream(stream)
            ));
        }

        return (
            <StreamPickerPage
                heading={game.home_team.name + " vs. " + game.visiting_team.name + "," + formatDate(game.start_time)}
                buttonClick={this.props.buttonClick}
                buttonLabel={"Back"}>
                {streamListItems}
            </StreamPickerPage>
        );
    }

    render () {
        switch(this.state.page) {
            case "streams":
                return this.renderStreams();
            case "games":
            default:
                return this.renderGames();
        }
    }
}

const LiveStreamPicker = ({onStartStream, errorMsg, streams, buttonClick}) => {
    let streamListItems;

    if (errorMsg) {
        streamListItems = renderError(errorMsg);
    } else {
        streamListItems = streams.map((stream) => (
            isValidStream(stream) ?
                <StreamPickerItem
                    key={stream.id}
                    onClick={() => onStartStream(stream)}>
                    {renderStreamLabel(stream)}
                </StreamPickerItem> :
                renderInvalidStream(stream)
        ));
    }

    return (
        <StreamPickerPage
            heading={"Live streams"}
            buttonClick={buttonClick}
            buttonLabel={"All games"}>
            {streamListItems}
        </StreamPickerPage>
    );
};

export default class StreamPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: "livestreams",
        };
    }

    render () {
        switch(this.state.page) {
            case "games":
                return (
                    <GameStreamPicker
                        onStartStream={this.props.onStartStream}
                        buttonClick={() => this.setState({page: "livestreams"})}/>
                );
            case "livestreams":
            default:
                return (
                    <LiveStreamPicker
                        onStartStream={this.props.onStartStream}
                        buttonClick={() => this.setState({page: "games"})}
                        streams={this.props.streams}
                        errorMsg={this.props.errorMsg}/>
                );
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/StreamPicker.js